/**
 * Ledger/IB disagreement — the two shapes an unrecorded settlement leaves.
 *
 * `status: 'unverifiable'` means no gateway answered. That is NOT a clean
 * book, and the UI must not render it as one.
 */
import { apiGet } from './client'

export interface Ghost {
  position_id: number
  osi_symbol: string | null
  net_qty: number | null
  account: string
  reason: string
}

export interface InverseGhost {
  symbol: string
  account: string
  sec_type: string
  ib_qty: number
  reason: string
}

export interface GhostsResponse {
  status: 'ok' | 'unverifiable'
  checked_accounts: string[]
  unverifiable_accounts: string[]
  ghosts: Ghost[]
  inverse_ghosts: InverseGhost[]
  as_of: string
}

export const getLedgerGhosts = () => apiGet<GhostsResponse>('/ledger/ghosts')
